import CheckIcon from "@mui/icons-material/Check";
import { Button, Select, MenuItem } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../components";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import PsModalWindow from "../../components/PsModalWindow";
import {
  _ListState,
  _SAVE_AGENCIES,
  _UPDATE_AGENCY,
  _UPDATE_PARTNER_BANK,
} from "../../models/agenciesModel";
import { formToObject } from "../../utils";

const PartnerBank = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_PARTNER_BANK(formToObject(form)).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Updated");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
      }
      setLoader(false);
    });
  };

  const field = (fieldName) => props.dataSource[fieldName] || "";

  return (
    <Spin spinning={loader}>
      <Form
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="id" value={field("id")} />

        {/* Company Name */}
        <Row className="mt-3">
          <Col md={3}>
            <PsLabel text="Bank Name" />
          </Col>
          <Col md={9}>
            <Form.Control
              type="text"
              name="bank_name"
              defaultValue={field("bank_name")}
              placeholder="Enter Bank Name"
              size="sm"
            />
          </Col>
        </Row>
        {/* Contact Person */}
        <Row className="mt-3">
          <Col md={3}>
            <PsLabel text="IFSC/SWIFT Code" />
          </Col>
          <Col md={9}>
            <Form.Control
              type="text"
              name="ifsc_code"
              defaultValue={field("ifsc_code")}
              placeholder="Enter IFSC/SWIFT Code"
              size="sm"
            />
          </Col>
        </Row>
        {/* Mobile No */}
        <Row className="mt-3">
          <Col md={3}>
            <PsLabel text="Account No" />
          </Col>
          <Col md={9}>
            <Form.Control
              type="text"
              name="account_no"
              defaultValue={field("account_no")}
              placeholder="Enter Account No"
              size="sm"
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={3}>
            <PsLabel text="Account Name" />
          </Col>
          <Col md={9}>
            <Form.Control
              type="text"
              name="account_name"
              defaultValue={field("account_name")}
              placeholder="Enter Account Name"
              size="sm"
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={3}>
            <PsLabel text="Branch Address" />
          </Col>
          <Col md={9}>
            <Form.Control
              as="textarea"
              name="branch_address"
              defaultValue={field("branch_address")}
              placeholder="Enter Branch Address"
              size="sm"
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Button type="submit" variant="contained" startIcon={<CheckIcon />}>
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default PartnerBank;
